module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.0.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PP1"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.2.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PP2"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.3.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 1",
      "src": "data/content-0002.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.3.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.2.0.0.box.636.508.426.128.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA1.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "158%",
      "text-align": "center",
      "font-weight": "bold",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.2.0.0.box.636.508.426.128.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1.w.4.0.0"
    }
  }), _vm._v("Majestic")]), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.6.0.0"
    }
  })]), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.7.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.8.0.0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.2.1.0.box.430.678.188.210.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1.w.9.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.10.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.11.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.12.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.3.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.3.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.4.0.0"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.4.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA1.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "0",
      "text-align": "center",
      "font-weight": "bold",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.2.1.0.box.430.678.188.210.q.101"
    }
  }, [_vm._v("MIDDLE TENNESSEE")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.2.10.0.box.614.1474.476.90.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA1.w.10.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "148%",
      "text-align": "center",
      "font-weight": "bold",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.2.10.0.box.614.1474.476.90.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA1.w.2.0.0"
    }
  }), _vm._v("Reid Smith")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.2.11.0.box.794.2162.124.112.q.0"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA1.w.3.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[ocr errors]",
      "src": "data/content-0003.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.3.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.2.12.0.box.487.2293.741.85.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA1.w.12.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "108%",
      "text-align": "center",
      "font-weight": "bold",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.2.12.0.box.487.2293.741.36.q.100"
    }
  }, [_vm._v("PELICAN PUBLISHING COMPANY")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA1.w.12.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "108%",
      "text-align": "center"
    },
    attrs: {
      "id": "para.2.12.1.box.717.2346.278.32.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA1.w.3.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.4.0.0"
    }
  }), _vm._v("GRETNA 1998")]), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.6.0.0"
    }
  })]), _c('a', {
    attrs: {
      "id": "GBS.PA2"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA2.w.0.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA2"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.3.0.0.box.0.0.1761.2686.q.0"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.2.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0004.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.2.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA3"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em",
      "margin-left": "5em"
    },
    attrs: {
      "id": "block.4.0.0.box.619.161.480.87.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "108%",
      "text-align": "center",
      "font-weight": "bold",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.4.0.0.box.619.161.480.87.q.70"
    }
  }, [_vm._v("This Book Is Humbly Dedicated")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em",
      "margin-left": "5em"
    },
    attrs: {
      "id": "block.4.1.0.box.553.280.620.442.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "font-weight": "bold",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.4.1.0.box.814.280.101.27.q.60"
    }
  }, [_vm._v("FIRST:")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_lineated",
    staticStyle: {
      "margin-left": "0",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.4.1.1.box.553.339.620.383.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("To ")]), _c('i', [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Dear ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Lord ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Heaven, ")]), _c('br'), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Who ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("not ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("only ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("supplied ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("thoughts, ")]), _c('br'), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Steadied ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("my ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("hand ")]), _c('br'), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("And ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("entered ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("my ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("heart ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("during ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("its ")]), _c('br'), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Writing, ")]), _c('br'), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("But ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Who ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("also ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("saw ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("bread ")]), _c('br'), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("On ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("our ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("table ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("while ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("this ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("effort ")]), _c('br'), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Was ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("being ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("made ")]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-left": "5em"
    },
    attrs: {
      "id": "block.4.2.0.box.553.745.611.585.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "font-weight": "bold",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.4.2.0.box.784.745.161.27.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.3.0"
    }
  }), _vm._v("AND TO:")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_lineated",
    staticStyle: {
      "margin-left": "0",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.4.2.1.box.553.803.611.527.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Mrs. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Reuben ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Algood, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("dear ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("friend, ")]), _c('br'), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Whose ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("boundless ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("enthusiasm, ")]), _c('br'), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Countless ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("hours ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("effort ")]), _c('br'), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("And ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("endless ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("storehouse ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("knowl- ")]), _c('br'), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("edge, ")]), _c('br'), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Not ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("only ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("helped ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("make ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("this ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("book ")]), _c('br'), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("A ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("reality— ")]), _c('br'), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("But ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("also ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("enabled ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("author ")]), _c('br'), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("To ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("come ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("know ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("love ")]), _c('br'), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Middle ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Tennessee ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("almost ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("as ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("much ")]), _c('br'), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("As ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("she ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("does. ")]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.4.4.0.box.129.1418.1498.170.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.4.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.4.4.0.box.129.1418.1498.170.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.1.0.0"
    }
  }), _vm._v("Credit for the excellent watercolors illustrating the Introduction and the Battles of Franklin and Nashville belongs to Bob Gray, a young Alabamian whose keen awareness of what this book is all about could not help but flow through the talented tip of his brush. Without Bob's efforts MAJESTIC MIDDLE TENNESSEE would not be the same.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-left": "5em"
    },
    attrs: {
      "id": "block.4.6.0.box.557.1718.1010.780.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.6.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-weight": "bold",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.4.6.0.box.559.1718.813.32.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.2.0.0"
    }
  }), _vm._v("Library of Congress Cataloging in Publication Data")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.6.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.4.6.1.box.558.1776.178.29.q.60"
    }
  }, [_vm._v("Smith, Reid.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.6.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "left",
      "margin-left": "1em",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.4.6.2.box.595.1814.406.31.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.2.1.0"
    }
  }), _vm._v("Majestic Middle Tennessee.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.6.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_lineated",
    staticStyle: {
      "margin-left": "0",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.4.6.3.box.560.1869.674.66.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.2.2.0"
    }
  }), _vm._v("   Reprint. Originally published: Prattville, Ala: "), _c('br'), _vm._v("Paddle Wheel Publications, c1975 "), _c('br')]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.6.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_lineated",
    staticStyle: {
      "margin-left": "0",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.4.6.4.box.558.1944.962.143.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.3.0.0"
    }
  }), _vm._v("    1. Historic buildings—Tennessee, Middle—Guide-books. "), _c('br'), _vm._v("2. Dwellings—Tennessee, Middle—Guide-books. 3. Architecture, "), _c('br'), _vm._v("Domestic—Tennessee, Middle—Guide-books. 4. Tennessee, "), _c('br'), _vm._v("Middle—Description and travel—Guide-books. I. Title. "), _c('br')]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.6.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "left",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.4.6.5.box.559.2092.617.32.q.50"
    }
  }, [_vm._v("[F442.2.S64 1983] ⠀917.68 ⠀8313328")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.6.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.4.6.6.box.560.2130.302.25.q.50"
    }
  }, [_vm._v("ISBN 0-88289-121-9")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.6.7.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-left": "0",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.4.6.7.box.559.2188.257.31.q.60"
    }
  }, [_vm._v("Copyright © 1982")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.6.8.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "left",
      "margin-left": "0",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.4.6.8.box.560.2225.539.32.q.70"
    }
  }, [_vm._v("By Pelican Publishing Company, Inc.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.6.9.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-left": "0",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.4.6.9.box.558.2263.266.32.q.90"
    }
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.6.10.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.4.6.10.box.560.2317.274.32.q.80"
    }
  }, [_vm._v("First printing, 1975")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.6.11.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.4.6.11.box.560.2354.392.32.q.70"
    }
  }, [_vm._v("First Pelican printing, 1982")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.6.12.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.4.6.12.box.557.2391.289.32.q.80"
    }
  }, [_vm._v("Third printing, 1983")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.6.13.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.4.6.13.box.559.2429.307.32.q.80"
    }
  }, [_vm._v("Fourth printing, 1990")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.6.14.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.4.6.14.box.559.2466.275.32.q.80"
    }
  }, [_vm._v("Fifth printing, 1998")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.6.15.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.4.6.15.box.1325.2466.242.28.q.90"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.3.1.0"
    }
  }), _vm._v("Printed ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("China ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA4"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.5.0.0.box.135.185.1503.445.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "108%",
      "text-align": "center",
      "font-weight": "bold"
    },
    attrs: {
      "id": "para.5.0.0.box.677.185.417.48.q.80"
    }
  }, [_vm._v("Acknowledgments")]), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.0.1.0"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.5.0.1.box.135.410.1503.220.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.1.0"
    }
  }), _vm._v("A special expression of gratitude goes to "), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.2.0"
    }
  }), _vm._v("Mr. and Mrs. John Bla"), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.3.0"
    }
  }), _vm._v("ir Jackson of Columbi"), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.4.0"
    }
  }), _vm._v("a for introducing the"), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.5.0"
    }
  }), _vm._v(" author to Majestic M"), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.2.0.0"
    }
  }), _vm._v("iddle Tennessee in the first place—t"), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.2.1.0"
    }
  }), _vm._v("o the members of the "), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.3.0.0"
    }
  }), _vm._v("Maury County Historic"), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.4.0.0"
    }
  }), _vm._v("al Association and lo"), _c('a', {
    attrs: {
      "id": "GBS.PA5"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.0.0.0"
    }
  }), _vm._v("cal chapter of the Association for the Preservation of Tennesse"), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.0.0"
    }
  }), _vm._v("e Antiquities who met"), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.1.0"
    }
  }), _vm._v(" together for endless"), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.2.0"
    }
  }), _vm._v(" hours to discuss the"), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.3.0"
    }
  }), _vm._v(" potential of this bo"), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.4.0"
    }
  }), _vm._v("ok and never gave up "), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.5.0"
    }
  }), _vm._v("hope along the way—"), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.2.0.0"
    }
  }), _vm._v("and finally, for the "), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.3.0.0"
    }
  }), _vm._v("generous hospitality and enthusiasm of tho"), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.3.1.0"
    }
  }), _vm._v("se owners of the hist"), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.3.2.0"
    }
  }), _vm._v("oric old places that "), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.4.0.0"
    }
  }), _vm._v("inspired this book:")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.4.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.0.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.1.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page full_page_skipped",
    attrs: {
      "id": "ORIG-GBS.PA5"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA6"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.7.0.0.box.132.184.1044.372.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "135%",
      "font-weight": "bold",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.7.0.0.box.132.184.1044.372.q.80"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Welcome ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("To ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("MAJESTIC ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("MIDDLE ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.7.1.0.box.128.599.1510.282.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "103%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.7.1.0.box.128.599.1510.282.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('b', [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.1.1.0"
    }
  }), _vm._v("TENNESSEE! ")])]), _vm._v("Here you will hear the heartbeat of history thunder through distant hills and echo through hollows where Time walks with silent footsteps. In this place the scarlet and gold flames of fall will seem to deceive your very eyes. Out of this earth the tender green shoots of spring may somehow implant themselves within the deepest reaches of your soul.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.7.2.0.box.132.986.901.224.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "103%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.7.2.0.box.132.986.901.224.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.3.0.0"
    }
  }), _vm._v("Here the great Andrew Jackson lived and loved his dear Rachel and bowed his proud head above her grave. From this place Knox Polk climbed out of the shadows of obscurity and into the presidential chair.")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    staticStyle: {
      "float": "none"
    },
    attrs: {
      "id": "block.7.3.0.box.1098.915.462.467.q.0"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.6.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0005.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.6.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.7.4.0.box.737.1522.902.310.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.4.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "103%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.7.4.0.box.737.1522.902.310.q.60"
    }
  }, [_vm._v("Here Davy Crockett stalked knoll and glade with the same restless strides that marched him to the Alamo and into the Halls of Glory. Perched on the knuckles of these hills, young Matt Maury pondered the mysteries of the Seven Seas and charted his way into the heart of every sailor who has ever dared sail them since.")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    staticStyle: {
      "float": "none"
    },
    attrs: {
      "id": "block.7.5.0.box.196.1386.444.544.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.7.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.8.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0006.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.8.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.7.6.0.box.130.2148.903.223.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.6.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "103%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.7.6.0.box.130.2148.903.223.q.50"
    }
  }, [_vm._v("Here, within the staunch muzzle of these valleys, John Bell Hood—a stiff-armed, one-legged memory of a man—wrote one of the bloodiest pages in American history, when never did so many die for so little in such a short time.")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    staticStyle: {
      "float": "none"
    },
    attrs: {
      "id": "block.7.7.0.box.1116.1862.416.522.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.0.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0007.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.0.0.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.0.0.0.2"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.2.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA7"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    staticStyle: {
      "float": "none"
    },
    attrs: {
      "id": "block.8.0.0.box.190.608.452.616.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.3.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0008.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.3.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.8.1.0.box.728.601.899.227.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "103%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.8.1.0.box.728.601.899.227.q.60"
    }
  }, [_vm._v("There lingers, too, in this place the ever green memory of a humble slave who once pledged his life three times to the end of a British rope and lived to walk away with the King's own medal for his unfailing loyalty to his master.")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    staticStyle: {
      "float": "none"
    },
    attrs: {
      "id": "block.8.2.0.box.1138.1036.388.600.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.4.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0009.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.4.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.8.3.0.box.128.1266.898.216.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "103%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.8.3.0.box.128.1266.898.216.q.60"
    }
  }, [_vm._v("In our own time, just as New Orleans gave birth to \"The Blues\", the hardy hand of these hills would rock the Cradle of Country Music until it grew into manhood as the world-renowned \"Nashville Sound\".")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    staticStyle: {
      "float": "none"
    },
    attrs: {
      "id": "block.8.4.0.box.266.1753.459.644.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.5.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0010.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.5.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.8.5.0.box.826.1825.801.544.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.5.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "103%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.8.5.0.box.826.1825.801.544.q.60"
    }
  }, [_vm._v("Welcome you are to MAJESTIC MIDDLE TENNESSEE! Among these hills you can hear the sands of the ages softly covering the tracks of the past. As you stand listening, off in the blue spray of distance some grand stallion may hoist his head to sniff the sweet scent of Man and Nature walking together. In this place there is the strange feeling—that, while stone walls and rail fences seem to wander aimlessly against the sky, they always somehow inevitably point toward the very altar of God.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.2.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    staticStyle: {
      "margin-bottom": "1.5em",
      "float": "none"
    },
    attrs: {
      "id": "block.9.0.0.box.0.0.1753.1463.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.2.0.0.1"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0011.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.2.0.0.2"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    staticStyle: {
      "float": "none"
    },
    attrs: {
      "id": "block.9.1.0.box.0.1468.496.232.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.2.0.0.3"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0012.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.2.0.0.4"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.2.0.0.5"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b32bebe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content-0013.vue
// module id = 54
// module chunks = 0